import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const WebsitesPage = lazy(() => import('../pages/websites/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/websites',
    element: <WebsitesPage />
  }
];

export default routes;